import React from "react"
import styled from "styled-components"
import Link from "../../component/link"

const DivMeans = styled.div`
  li:hover > a {
    color: #1465ff;
  }
`

export const ARRAY_LINKS = [
  {
    name: "Políticas de privacidad",
    url: "https://softwaredecolombia.com/privacidad/",
  },
  {
    name: "Términos y condiciones",
    url: "https://softwaredecolombia.com/condiciones/",
  },
  {
    name: "Soporte",
    url: "/soporte",
  },
  {
    name: "Implementación",
    url: "/implementacion",
  },
  {
    name: "Blog",
    url: "/blog",
  },
]

const MenuMeans = () => {
  return (
    <DivMeans className="border-top-menu bg-white absolute z-10 transform mt-3 px-2 w-screen max-w-xs sm:px-0">
      <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
        <div className="grid gap-12">
          <div className="ml-4 text-left">
            <ul className="grid">
              {ARRAY_LINKS &&
                ARRAY_LINKS.map(({ name, url }, i) => {
                  return (
                    <li key={i}>
                      <Link
                        to={url}
                        className="inline-block pl-2 p-4 text-sm text-gray-500 rounded-lg"
                        rel={url.startsWith("https://") || url.startsWith("http://") ? "noopener noreferrer" : undefined}
                        target={url.startsWith("https://") || url.startsWith("http://") ? "_blank" : undefined}
                      >
                        {name}
                      </Link>
                    </li>
                  )
                })}
            </ul>
          </div>
        </div>
      </div>
    </DivMeans>
  )
}
export default MenuMeans
